var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.state.settings && _vm.state.settings.layout === "list"
    ? _c(
        "span",
        {
          staticClass: "dropdown-item-text text-nowrap c-pointer",
          attrs: { "data-v-step": "viewswitch" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.switchLayoutTrello.apply(null, arguments)
            }
          }
        },
        [
          _vm._v("\n  " + _vm._s(_vm.$t("kanbanViewTrello")) + " / "),
          _c(
            "span",
            {
              staticClass: "badge badge-primary",
              staticStyle: { "font-size": "1em" }
            },
            [_vm._v(_vm._s(_vm.$t("kanbanViewList")))]
          )
        ]
      )
    : _vm.state.settings && _vm.state.settings.layout === "trello"
    ? _c(
        "span",
        {
          staticClass: "dropdown-item-text text-nowrap c-pointer",
          attrs: { "data-v-step": "viewswitch" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.switchLayoutList.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "badge badge-primary",
              staticStyle: { "font-size": "1em" }
            },
            [_vm._v(_vm._s(_vm.$t("kanbanViewTrello")))]
          ),
          _vm._v(" / " + _vm._s(_vm.$t("kanbanViewList")) + "\n")
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }